import React from 'react';
import PropTypes from 'prop-types';
import colors from 'customizations/js/color-variables';

export const IconRecommended = ({ className }) => (
  <svg className={className} width="36" height="31" viewBox="0 0 36 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className="icon-filled-path" d="M30.6678 10.1065H21.5723L21.8584 5.99805C21.9492 4.69363 21.4594 3.39822 20.5145 2.44398C18.0555 -0.039404 13.6913 0.662275 12.2515 3.79572L9.35129 10.1065H2.05231C1.46343 10.1065 0.986099 10.558 0.986099 11.1148V29.048C0.986099 29.6048 1.46343 30.0562 2.05231 30.0562H10.0505C10.6013 30.0562 11.0545 29.6611 11.1107 29.1543H19.6173C25.7286 29.1543 31.1678 25.4818 33.152 20.0157L34.7746 15.5459C35.7421 12.8809 33.6558 10.1065 30.6678 10.1065ZM3.11851 12.123H8.98425V28.0397H3.11851V12.123ZM32.7578 14.8911L31.1351 19.3611C29.4465 24.0126 24.8179 27.1378 19.6172 27.1378H11.1167V11.3244L14.2072 4.59936C14.6651 3.60283 15.7034 2.95894 16.8525 2.95894C18.5117 2.95894 19.8408 4.28132 19.7305 5.8656L19.3696 11.0486C19.3293 11.6294 19.8167 12.123 20.4336 12.123H30.6678C32.1842 12.123 33.2513 13.5314 32.7578 14.8911Z" fill={colors.gray30} stroke={colors.gray30} strokeWidth="0.770182" />
  </svg>
);

IconRecommended.propTypes = {
  className: PropTypes.string,
};

IconRecommended.defaultProps = {
  className: '',
};
